import member from './memberReducer';
import orgTreeFolder from './orgTreeReducer';
import memberSearch from './memberSearchReducer';
import memberInfo from './memberInfReducer';
import fieldSettings from './fieldSettingsReducer';
import { combineReducers } from 'redux';

export default combineReducers({
  memberInfo,
  orgTreeFolder,
  member,
  memberSearch,
  fieldSettings,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyTeams/reducers/index.js
 **/